import { useAmplitude } from 'hooks/useAmplitude';
import { useGlobals } from 'hooks/useGlobals';
import { useTracking } from 'hooks/useTracking';
import { useNavigate } from 'react-router-dom';
import { sendUpsellRequestToBlip } from 'services/blip';

const useHandlePlanUpgrade = () => {
  const { sendAmplitude } = useAmplitude();
  const { sendTracking } = useTracking();
  const navigate = useNavigate();

  const globals = useGlobals();
  const companyId = globals?.user?.data?.company?.id;
  const userId = globals?.user?.data?.id;
  const combo = globals?.user?.data?.company?.combo?.name;
  const isFocoNotPremium = globals?.foco?.isFocoNotPremium;

  const eventsCommomData = {
    companyId,
    userId,
    combo,
  };

  const handlePlanUpgradeClick = (source: 'botao-mudar-de-plano' | 'saiba-mais', openUpsellModal: () => void) => {
    sendTracking({
      event: {
        name: 'trucker_listing_access_required',
      },
      source,
      data: {
        ...eventsCommomData,
        companyId: `hashed|${companyId}`,
      },
    });

    sendAmplitude('trucker_listing_access_required', {
      ...eventsCommomData,
      source,
    });

    sendUpsellRequestToBlip('show-more-truckers');

    if (isFocoNotPremium) {
      openUpsellModal();
      return;
    }

    navigate('/novos-planos');
  };

  const handleFormModalUpsellEvents = (source: 'change-plan-ask-for-contact' | 'learn-more-ask-for-contact') => {
    sendTracking({
      event: {
        name: 'trucker_listing_active_whatsapp',
      },
      source,
      data: {
        ...eventsCommomData,
        companyId: `hashed|${companyId}`,
      },
    });

    sendAmplitude('trucker_listing_active_whatsapp', {
      ...eventsCommomData,
      source,
    });
  };

  return { handlePlanUpgradeClick, handleFormModalUpsellEvents };
};

export default useHandlePlanUpgrade;
